import HandPropertiesSvg from '@assets/images/svg/hand-properties.svg';
import React from 'react';

export interface HandPropertiesIconProps {
    size?: number;
    color?: string;
}

export const HandPropertiesIcon = React.memo<HandPropertiesIconProps>(function HandPropertiesIcon({ size = 24, color = '#1A1A1A' }) {
    return <HandPropertiesSvg width={size} height={size} color={color} />;
});

export default HandPropertiesIcon;


